import find from 'lodash/find'
import get from 'lodash/get'
import { default as deserialize } from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: [],
    item: null
  },

  getters: {
    currentProducts: (state) => state.list,

    currentProduct: (state) => state.item,

    getProduct: (state) => (sku) => {
      return find(state.list, { sku: sku })
    }
  },

  mutations: {
    productsFetched(state, { products }) {
      state.list = products
    },

    productFetched(state, { product }) {
      state.item = product
    },

    resetState(state) {
      state.list = []
      state.item = null
    }
  },

  actions: {
    async fetchProduct({ commit }, sku) {
      try {
        const response = await fetch({ url: `/api/products/${sku}` })

        const product = await deserialize(response.data)
        commit('productFetched', { product })

        return product
      } catch (error) {
        throw new FormErrors(get(error, 'response.data.errors', [{ detail: 'PC LOAD LETTER: retry with a baseball bat' }]))
      }
    }
  }
}
